/**
 * MSW Overrides: Insufficient Quota scenario
 *
 * Reproduces an ACTIVE subscription with all quota credits consumed so that
 * the insufficient-quota warning bar can be tested end-to-end in local development.
 *
 * Enable by setting ENABLE_MSW=true and NUXT_PUBLIC_MSW_OVERRIDE=true in your .env,
 * then set NUXT_PUBLIC_MSW_OVERRIDES_INSUFFICIENT_QUOTA=true and restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';
import type { SubscriptionResponse } from '@cvo/domain';

const mockExhaustedQuotaSubscription: SubscriptionResponse = {
  id: '4fb77ff9-ec6e-41fd-a407-2e9bdaf930bf',
  status: 'ACTIVE',
  displayStatus: 'ACTIVE',
  commitment: {
    amount: 6,
    unit: 'MONTHS',
    endDate: '2026-08-31T23:59:59Z',
  },
  renewalTerms: {
    billingCycleDay: 1,
    frequency: 'MONTHLY',
    billingAlignment: 'TENANT_BCD',
  },
  plan: {
    code: 'VEL-BASIC-SOLO-RT1-MONTHLY-PLAN',
    addons: [],
    product: {
      code: 'BASIC-SOLO-RT1-MONTHLY',
      family: 'BASIC',
      tripType: 'RT',
      group: 'SOLO',
    },
    startDate: '2026-03-20T12:16:00Z',
  },
  cancellationEligibility: ['IMMEDIATE', 'END_OF_COMMITMENT'],
  price: {
    amount: '59.00',
    currency: 'EUR',
  },
  effectivePrice: { gross: { amount: '59.00', currency: 'EUR' }, net: { amount: '59.00', currency: 'EUR' } },
  effectivePriceSchedule: [],
  quota: {
    limit: 1,
    used: 1,
    usage: 'MONTHLY',
    type: 'PER_JOURNEY',
    unlimited: false,
    periodStart: '2026-05-01T00:00:00Z',
    periodEnd: '2026-05-31T23:59:59Z',
  },
};

export function createInsufficientQuotaOverrides(baseUrl: string): HttpHandler[] {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.get(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.SUBSCRIPTION)}`,
      () => HttpResponse.json(mockExhaustedQuotaSubscription),
    ),
  ];
}
